import 'styled-components'
import { useState } from 'react'
import HeaderMenu from './HeaderMenu'
import HeaderNav from './HeaderNav'

function Header() {
	const [infoMenu, setInfoMenu] = useState(false)
	const [navMenu, setNavMenu] = useState(false)

	return (
		<header
			id='top-menu'
			className='h-[35px] lg:h-[45px] xl:hidden bg-white dark:bg-dark-300 fixed w-full right-0 top-0 border-b-2 border-gray-200 dark:border-dark-200 z-20'
		>
			<div className='container h-full flex items-center justify-between w-full'>
				<HeaderMenu
					isInfoOpen={infoMenu}
					isNavOpen={navMenu}
					setInfoOpen={state => setInfoMenu(state)}
					setNavOpen={state => setNavMenu(state)}
					onBurgerClick={() => setInfoMenu(!infoMenu)}
				/>
				<HeaderNav
					isInfoOpen={infoMenu}
					isNavOpen={navMenu}
					setInfoOpen={state => setInfoMenu(state)}
					setNavOpen={state => setNavMenu(state)}
					onDotsClick={() => setNavMenu(!navMenu)}
				/>
			</div>
		</header>
	)
}

export default Header
